import { useMemo, useRef } from "react";
import { motion, useInView } from "framer-motion";

// Reveal-on-scroll wrapper.
// Uses a stable ref + useInView so that on client-side route changes the
// element is re-observed reliably (avoids content occasionally staying hidden
// at opacity:0 until a manual refresh). `amount: 0.1` triggers as soon as a
// small part of the element is visible, so above-the-fold content always shows.
const IN_VIEW_OPTIONS = { once: true, amount: 0.1 };
const EASE = [0.21, 0.47, 0.32, 0.98];
const VISIBLE = { opacity: 1, y: 0 };

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, IN_VIEW_OPTIONS);
  const hidden = useMemo(() => ({ opacity: 0, y }), [y]);
  const transition = useMemo(() => ({ duration: 0.6, delay, ease: EASE }), [delay]);
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={hidden}
      animate={inView ? VISIBLE : hidden}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};
